export enum Feature {
  PLATE_SCAN = 'plateScan',
  AIR_TECHNIQUES_REBRAND = 'airTechniquesRebrand',
  PRODUCT_REGISTRATION_ACKNOWLEDGEMENT = 'productRegistrationAcknowledgement',
  SETUP_GUIDE = 'setupGuide'
}

export type Announcement = {
  key: Feature
  title: string
  descriptions: string[]
  icon: string
  images: string[]
}

export const ANNOUNCEMENTS: Announcement[] = []
